export default __webpack_public_path__ + "static/media/face_2_46.3ae8fff6.png";